import { useEffect } from "react";

// The admin tables are grids of <div>/<span> (".table" / ".admin-table").
// On phones they turn into one card per row, and each value needs its column
// name next to it: copy the header texts onto the cells as data-label.
const TABLES = [
  { table: ".table", head: ".table-head", row: ".table-row" },
  { table: ".admin-table", head: ".admin-table__head", row: ".admin-table__row" },
];

function labelTables(root) {
  TABLES.forEach(({ table, head, row }) => {
    root.querySelectorAll(table).forEach((tableEl) => {
      const headEl = tableEl.querySelector(`:scope > ${head}`);
      if (!headEl) return;
      const labels = [...headEl.children].map((cell) => cell.textContent.trim());
      tableEl.querySelectorAll(`:scope > ${row}`).forEach((rowEl) => {
        [...rowEl.children].forEach((cell, index) => {
          const label = labels[index] || "";
          if (cell.getAttribute("data-label") !== label) cell.setAttribute("data-label", label);
        });
      });
    });
  });
}

export default function TableLabels() {
  useEffect(() => {
    let frame = null;
    const run = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => labelTables(document));
    };
    run();
    const observer = new MutationObserver(run);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
    };
  }, []);
  return null;
}
